import axios from 'axios'
import config from './config'
import md5 from 'js-md5'
import QS from 'qs';
import {ElMessage} from 'element-plus'
import {router} from '../router'
import {getLanguage, isMobileDevice, getOS, getBrowserName} from '../util/index'
// import { useRouter } from 'vue-router'
// const router = useRouter()
//用户信息
import {userInfo} from '../util/globalStore'
// axios 配置
axios.defaults.baseURL = config.host
axios.defaults.timeout = 120000 // 设置接口响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

function _transformUA(url, data) {
	const user = userInfo()
	let userID = user.id
	let accessToken = user.login_access_token
	let currentTimeStmp = Math.round(new Date() / 1000)
	let sign = md5( userID + '21meNQbscvLvpT8A' + currentTimeStmp )
	const browserLanguage = getLanguage()
	const platform = isMobileDevice() ? '1' : '2'
	// 系统 | 系统版本号 | 客户端版本号 | 包名 | 设备id|屏幕宽| 屏幕高|越狱| 登录用户UID|当前时间戳|sign|accessToken|手机品牌名 | 设备语言
	return getOS() + '|' + config.version + "|" + config.requestVersion + '|' + config.package + "|" + platform + "|" + "|" + "|" + '|' +
		userID + '|' + currentTimeStmp + "|" + sign + "|" + accessToken + "|" + getBrowserName() + "|" + browserLanguage
}
export default {}

// 封装get请求
export function get(url, params = {}, showError = true) {
	return new Promise((resolve, reject) => {
		// let ua = _transformUA(url, params);
		// axios.defaults.headers.common['sign'] = ua.sign
		// axios.defaults.headers.common['rid'] = ua.rid
		axios
			.get(url, {
				params: params
			})
			.then(response => {
				resolve(response)
			})
			.catch(err => {
				reject(err)
			})
	})
}

// 封装post请求
export function post(url, data = {}, showError = true) {
	return new Promise((resolve, reject) => {
		let ua = _transformUA(url, data)
		axios.defaults.headers.common['ua'] = ua;
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
		axios.post(url, QS.stringify(data)).then(
			response => {
				if (config.debug) {
					// console.log("🟢 🟡", url, "\nreq", data, "\nres", response.data)
				}
				if (response.data.ok == '-6') {
					//跳转登录
					const user = userInfo()
					user.logout()
					router.push('/login');
					reject(response.data)
				} else if (response.data.ok == '302') {
					router.push('/error');
					reject(response.data)
				} else if (response.data.ok != 1) {
					if (showError) {
						ElMessage.error('' + response.data.msg)
					}
					reject(response.data)
				} else {
					resolve(response.data)
				}
			},
			err => {
				if (err.response) {
					if (err.response.status == 500) {
						if (config.debug) {
							ElMessage.error('Http Error Code 500');
						}
						console.error('HTTP错误状态码:', err.response.status, '错误信息:', err.response.data);
					}else {
						console.error('' + err);
						// ElMessage.error('' + err);
					}
				} else {
					console.error('' + err);
					// ElMessage.error('' + err);
				}
				reject(err)
			}
		)
	})
}


// 封装post请求音频
export function postAudio(url, data = {}, showError = true) {
	return new Promise((resolve, reject) => {
		let ua = _transformUA(url, data)
		// axios.defaults.headers.common['sign'] = ua.sign;
		axios.defaults.headers.common['ua'] = ua;
		// axios.defaults.headers.post['Content-Type'] = 'application/json';
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
		axios.defaults.headers.post['responseType'] ='blob'
		axios.post(url, QS.stringify(data), {responseType: "blob"}).then(
			response => {
				if (config.debug) {
					// console.log("🟢 🟡", url, "\nreq", data, "\nres", response.data)
				}
				resolve(response)
			},
			err => {
				// ElMessage.error('' + err);
				console.error('' + err);
				reject(err)
			}
		)
	})
}

// 封装upload请求
export function upload(url, data = {}, fileName, file, showError = true) {
	const formData = new FormData();
	let keys = Object.keys(data)
	for (var i = 0; i < keys.length; i++) {
		let key = keys[i]
		formData.append(key, data[key])
	}
	formData.append(fileName, file)

	return new Promise((resolve, reject) => {
		let ua = _transformUA(url, data);
		axios.defaults.headers.common['ua'] = ua;
		// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
		axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
		axios.post(url, formData, {
			onUploadProgress: function (axiosProgressEvent) {
				console.log('上传进度: ', axiosProgressEvent.progress)
				// ElMessage('上传进度: ' + axiosProgressEvent.progress * 100 + '%');
			}
		}).then(response => {
			if (response.data.ok == -6) {
				//跳转登录
				setTimeout(function () {
					router.push({
						name: 'login'
					});
				}, 2000);
				reject(response.data)
			} else if (response.data.ok != 1) {
				if (showError) {
					ElMessage.error('' + response.data.msg);
				}
				reject(response.data)
			} else {
				resolve(response.data)
			}
		},
			err => {
				reject(err)
			}
		)
	})
}

export function download(url, params = {}, fileName = 'download', showError = true) {
	return new Promise((resolve, reject) => {
		// let ua = _transformUA(url, params);
		// axios.defaults.headers.common['sign'] = ua.sign
		// axios.defaults.headers.common['rid'] = ua.rid
		axios
			.post(url, QS.stringify(params), {
				responseType: 'blob',
				onDownloadProgress(e) {
					if (e.lengthComputable) {
						response.textContent = Math.round((e.loaded * 100) / e.total) + '%';
					  if (e.loaded === e.total) {
						response.textContent += `，用时：${e.timeStamp.toFixed(0)}ms`;
					  }
					}
				},
			})
			.then(response => {
				if (config.debug) {
					console.log("🟢 🟡", url, "\nreq", params, "\nres", response.data)
				}
				// const blob = new Blob([response.data]);//处理文档流
				// const elink = document.createElement('a');
				// elink.download = fileName;
				// elink.style.display = 'none';
				// elink.href = URL.createObjectURL(blob);
				// document.body.appendChild(elink);
				// elink.click();
				// URL.revokeObjectURL(elink.href); // 释放URL 对象
				// document.body.removeChild(elink);
				// const blobUrl = URL.createObjectURL(response.data);
				resolve(response.data)
			})
			.catch(err => {
				reject(err)
			})
	})
}

export function downloadGet(url, params = {}, fileName = 'download', showError = true) {
	return new Promise((resolve, reject) => {
		// let ua = _transformUA(url, params);
		// axios.defaults.headers.common['sign'] = ua.sign
		// axios.defaults.headers.common['rid'] = ua.rid
		axios.defaults.headers.get['Content-Type'] = 'application/pdf;charset=UTF-8';
		axios
			.get(url, {
				params: params
			}, {
				responseType: 'blob',
				onDownloadProgress(e) {
					if (e.lengthComputable) {
						response.textContent = Math.round((e.loaded * 100) / e.total) + '%';
						if (e.loaded === e.total) {
							response.textContent += `，用时：${e.timeStamp.toFixed(0)}ms`;
						}
					}
				},
			})
			.then(response => {
				if (config.debug) {
					// console.log("🟢 🟡", url, "\nreq", params, "\nres", response.data)
				}
				// const blob = new Blob([response.data]);//处理文档流
				// const elink = document.createElement('a');
				// elink.download = fileName;
				// elink.style.display = 'none';
				// elink.href = URL.createObjectURL(blob);
				// document.body.appendChild(elink);
				// elink.click();
				// URL.revokeObjectURL(elink.href); // 释放URL 对象
				// document.body.removeChild(elink);
				// const blobUrl = URL.createObjectURL(response.data);
				resolve(response)
			})
			.catch(err => {
				reject(err)
			})
	})
}